import { useAgedAccounts } from "@apis/accounts/useAccounts"
import { DataTable } from "@components/DataTable/DataTable"
import { PageTitle } from "@components/PageTitle"
import { Badge } from "@components/ui/badge"
import { Card, CardAction, CardHeader, CardTitle } from "@components/ui/card"
import {
  agedAccountsColumns,
  agedAccountsFilters,
} from "@pages/AgedAccounts/utils/tableColumnsSchema"
import { useFiltersState } from "@hooks/useFiltersState"
import { usePaginationState } from "@hooks/usePaginationState"
import { useSortingState } from "@hooks/useSortingState"
import { Loader2 } from "lucide-react"

export const AgedAccounts = () => {
  const { data, isPending, isFetching } = useAgedAccounts()
  const filters = useFiltersState()
  const sorting = useSortingState()
  const pagination = usePaginationState()

  return (
    <div className="tw:flex tw:flex-col tw:gap-4">
      <PageTitle title="Aged Pending Accounts Queue" />
      <Card>
        <CardHeader>
          <CardTitle className="tw:flex tw:items-center tw:gap-2">
            <span>Total count:</span>
            {data && <Badge>{data.length}</Badge>}
          </CardTitle>
          <CardAction>
            {isFetching && <Loader2 className="tw:animate-spin" />}
          </CardAction>
        </CardHeader>
      </Card>
      <DataTable
        pending={isPending}
        columns={agedAccountsColumns}
        data={data ?? []}
        filters={agedAccountsFilters}
        paginationType="client"
        {...filters}
        {...sorting}
        {...pagination}
      ></DataTable>
    </div>
  )
}
